import { z } from "zod";
import { TAXONOMY_GAP_KINDS } from "@shared/types/taxonomy.ts";

/** The statuses the Gaps list can be narrowed to; a filled gap is done and not listed. */
export const GAP_STATUS_FILTERS = ["all", "escalated", "open", "decided"] as const;

/** What narrows the Gaps list. It lives in the URL, so a link opens the same view. */
export const taxonomyGapFiltersSchema = z.object({
  status: z.enum(GAP_STATUS_FILTERS).default("all"),
  kind: z.enum(["all", ...TAXONOMY_GAP_KINDS]).default("all"),
});

export type TaxonomyGapFilters = z.output<typeof taxonomyGapFiltersSchema>;
